import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import { tailwindOverride } from '@getsynapse/design-system';
import type { NavItem } from '../types';
import NavItemWrapper from './NavItem/NavItemWrapper';
import NavItemLink from './NavItem/NavItemLink';
import NavItemTooltip from './NavItem/NavItemTooltip';
import { NAV_ITEM_LABEL_CHAR_LIMIT } from '../constant';
import './Body.css';

interface BodyProps extends ComponentPropsWithoutRef<'nav'> {
  itemGroups: NavItem[][];
  renderItem?: (item: NavItem, isExpanded: boolean) => ReactNode;
  isExpanded: boolean;
}

const Body: FC<BodyProps> = ({ itemGroups, isExpanded, renderItem }) => {
  return (
    <nav
      className='space-y-2 flex-grow px-1 overflow-y-auto scrollbar'
      id='main-nav-content'
      aria-label='Main navigation menu'
    >
      <ul>
        {itemGroups.map((group, i) => {
          return group.length !== 0 ? (
            <div key={i}>
              {group.map((item, j) => (
                <div key={j}>
                  <NavItemTooltip
                    content={item.label}
                    offset={[20, 0]}
                    hidden={
                      item.label.length < NAV_ITEM_LABEL_CHAR_LIMIT &&
                      isExpanded
                    }
                  >
                    <NavItemWrapper
                      className={tailwindOverride(
                        'hover:bg-olive-green',
                        'hover:bg-opacity-30',
                        {
                          'border-transparent': !item.isActive,
                          'bg-olive-green': item.isActive,
                          'bg-opacity-60': item.isActive,
                        }
                      )}
                      style={{
                        borderColor:
                          item.isActive && item.activeBorderColor
                            ? item.activeBorderColor
                            : undefined,
                        marginTop: '1px',
                        marginBottom: '1px',
                      }}
                    >
                      {renderItem ? (
                        renderItem(item, isExpanded)
                      ) : (
                        <NavItemLink item={item} isExpanded={isExpanded} />
                      )}
                    </NavItemWrapper>
                  </NavItemTooltip>
                </div>
              ))}

              {i !== itemGroups.length - 1 ? (
                <div className='h-px flex-1 bg-olive-green w-full my-1'></div>
              ) : null}
            </div>
          ) : null;
        })}
      </ul>
    </nav>
  );
};

export default Body;
